// extracted by mini-css-extract-plugin
module.exports = {"title":"UpdatesPanel_title_1crRo","description":"UpdatesPanel_description_2k1V3","versions":"UpdatesPanel_versions_RDbWS","versions-card":"UpdatesPanel_versions-card_gw8ew"};